import type { SolutionSector } from "../sectors";
import { ASK_LINE, LOGO } from "./shared";

export const TECHNOLOGY: SolutionSector = {
  slug: "technology",
  name: "Technology companies",
  demoOrg: "Demo (TMT)",
  story: "technology",
  metadata: {
    title: "AI for customer commitment reviews | Your Twin",
    description:
      "See which customer commitments depend on unfinished work before the next customer update. Your Twin connects HubSpot, Linear, GitHub and Slack.",
  },
  hero: {
    label: "Technology companies",
    title: ["Check the", "work behind", "the date."],
    lead: [
      "Spend less time piecing together customer commitments. Your Twin connects commitments in ",
      LOGO.hubspot,
      " with work in ",
      LOGO.linear,
      ", releases in ",
      LOGO.github,
      " and updates in ",
      LOGO.slack,
      ", so you can see which dates depend on unfinished work before the next customer update.",
    ],
    cta: "Bring a customer commitment",
    buyer: "For COOs, delivery directors and heads of customer success at B2B technology companies",
    instrumentLabel: "The delivery Twin · Customer, commitment, work and owner",
    legendLines: [
      "Read HubSpot, Linear, GitHub and Slack.",
      "Link each customer commitment to its issues, pull requests and releases.",
      "Build one picture of each commitment and the work behind it.",
      "Check the connections and dates against your source records.",
      "Have agents prepare commitment reviews and flag unfinished work.",
      "Save their work in shared channels: commitment registers and release tables.",
      ASK_LINE,
    ],
  },
  replay: {
    title: "Which dates depend\non unfinished work?",
    lead: "Ask across HubSpot, Linear, GitHub and Slack. See each commitment beside its linked work, release and owner.",
  },
  outcomes: {
    title: "Every date checked\nagainst the work.",
    lead: "Customer teams see the delivery records behind each commitment before they confirm it.",
    items: [
      { title: "Connect the promise to the work.", body: "See the delivery records behind a customer date.", show: "sources" },
      { title: "Expose the open dependency.", body: "Bring unfinished work into the customer review.", show: "status" },
      { title: "Keep the commitment with your team.", body: "Check the evidence before you confirm a date.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose a customer commitment that is hard to trace today." },
  questions: [
    { q: "Does it replace Linear or GitHub?", a: "No. Your team keeps managing delivery there. The Twin reads the connected records." },
    { q: "Can it tell us whether a feature is live?", a: "Only when the connected records show it. A completed issue or a merged change isn’t enough on its own." },
    {
      q: "Does this cover telecoms operations?",
      a: "No. This workflow covers customer commitments and delivery. Network, usage and billing systems would need their own connectors and checks.",
    },
  ],
  closing: "Start with one customer commitment\nthat is hard to trace.",
};
